import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'large-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    RouterLink
  ],
  templateUrl: './large-sidebar.component.html',
  styleUrl: './large-sidebar.component.css'
})
export class LargeSidebarComponent implements OnInit {
  icons = Icons;
  pageRoute: string = '';

  @Input() sidebarStatus: string = '';  
  @Output() sidebarStatusChange = new EventEmitter<string>();


  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.updatePageRoute();
    });
    this.updatePageRoute();
  }

  private updatePageRoute() {
    const url = this.router.url.replace(/\/+$/, ''); // remove trailing slash
    const segments = url.split('/');
    this.pageRoute = segments[1];
  }
  
  navigateToPage(route: string): void {
    this.router.navigate([route]);
  }
  
  toggleSidebar(): void {
    this.sidebarStatus = this.sidebarStatus === 'large' ? 'small' : 'large';
    this.sidebarStatusChange.emit(this.sidebarStatus);
  }

}
